/* Copyright (c) 2022-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { theme } from "@nordcloud/gnui";
import {
  Option,
  OptionInner,
} from "~/views/settings/CostSplittingRulesPage/styles";
import { RadioOptionTable, RadioOptionProps } from "./RadioOptionTable";

export function OptionWithRadioButton({
  option,
  isChecked,
  showSettingsButton,
  onSettingsClick,
  onOptionChange,
}: RadioOptionProps) {
  return (
    <Option
      key={option?.label}
      selected={false}
      style={{ padding: theme.spacing.spacing02 }}
      withHover={false}
    >
      <OptionInner
        style={{
          width: "100%",
          marginLeft: theme.spacing.spacing00,
          textAlign: "left",
        }}
      >
        <RadioOptionTable
          option={option}
          isChecked={isChecked}
          showSettingsButton={showSettingsButton}
          onSettingsClick={onSettingsClick}
          onOptionChange={onOptionChange}
        />
      </OptionInner>
    </Option>
  );
}
